import {
  IconButton, makeStyles, Paper, Typography,
} from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { EditRounded } from '@material-ui/icons';
import { householdEditRecordExpenseUri } from 'Consts/advisorUris';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2, 0, 2, 0),
    margin: theme.spacing(1),
  },
  row: {
    padding: theme.spacing(0, 2, 0, 2),
    display: 'flex',
    justifyContent: 'space-between',
    width: theme.dimensions.md,
    '&:nth-child(even)': {
      backgroundColor: theme.palette.facet.lightGray,
    },
    '&:last-child': {
      marginTop: 'auto',
    },
  },
  editable: {
    textAlign: 'right',
  },
  content: {
    marginTop: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    root: {
      width: '100%',
    },
    row: {
      width: '100%',
    },
  },
}));

export default function ExpenseTable({
  title,
  total,
  expensesCollection,
}) {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();

  const expenseResources = expensesCollection?.resources()?.list();

  return (
    <Paper className={classes.root}>
      <div className={classes.row}>
        <Typography unselectable variant="h3" color="primary">
          {title}
        </Typography>
        <IconButton
          href={householdEditRecordExpenseUri(householdResource.id())}
          size="small"
          color="primary"
        >
          <EditRounded />
        </IconButton>
      </div>
      {expenseResources?.map((expenseResource) => {
        return (
          <div className={classes.content}>
            <div
              className={classes.row}
              key={`snapshot-sub-expense-${expenseResource.id()}`}
            >
              <Typography variant="body1">
                {expenseResource.attr('name')}
              </Typography>
              <Typography variant="body1" className={classes.subtitle}>
                ${expenseResource.attr('value')}
              </Typography>
            </div>
          </div>
        );
      })}
      <div className={classes.row}>
        <Typography unselectable variant="body1" color="primary">
          Total
        </Typography>
        <Typography unselectable variant="body1" color="primary">
          ${total ? total.toLocaleString() : 0}
        </Typography>
      </div>
    </Paper>
  );
}

ExpenseTable.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  expensesCollection: PropTypes.object.isRequired,
};
